// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AUTOMATIC_COMMENT_VIOLATES_RULES = "Nahlas nevhodnou odpov\u011bd";
export const SEO_TITLE_BLOGS_SHORT_MESSAGE_OF_username = "Kr\u00e1tk\u00e1 zpr\u00e1va u\u017eivatelky %(username)s";
